var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',[_c('div',{staticClass:"r-alert",class:[_vm.alertStyle ? 'r-alert--' + _vm.alertStyle : '']},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }